import React from "react";
import { useTranslation } from "react-i18next";
import defaultLogo from "@/assets/smrt-menu-logo.png";

interface UploadImagePreviewProps {
  currentImageUrl?: string;
  newImageFile?: File | null;
  t?: (key: string, defaultText?: string) => string;
}

const UploadImagePreview: React.FC<UploadImagePreviewProps> = ({
  currentImageUrl,
  newImageFile,
}) => {
  const { t } = useTranslation();

  // if (!currentImageUrl && !newImageFile) return null;
  currentImageUrl = currentImageUrl ? currentImageUrl : defaultLogo;

  const label = newImageFile
    ? t("input.newImagePreview", "New Image Preview")
    : t("input.currentImage", "Current Image");

  const src = newImageFile
    ? URL.createObjectURL(newImageFile)
    : currentImageUrl;

  return (
    <div className="mb-2">
      <img
        src={src}
        alt={label}
        className="h-20 w-20 object-contain border rounded"
      />
      <div className="text-xs text-gray-500">{label}</div>
    </div>
  );
};

export default UploadImagePreview;
